












import { defineComponent, ref } from '@vue/composition-api';

const name = 'ttam-promotion-pixel-checkbox';

export default defineComponent({
  name,
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const emptyText = ref('');
    const onInput = (val: boolean) => {
      emit('input', val);
    };
    return {
      name,
      emptyText,
      onInput,
    };
  },
});
